import React from 'react'
import createReactClass from 'create-react-class'
import './select-dropdown.scss'
import FaShareAlt from 'react-icons/lib/fa/share-alt'
import {filter, propEq} from 'ramda'

export default createReactClass({
  getInitialState () {
    return {
      isOpen: false,
    }
  },

  renderOptions () {
    let list = [...this.props.data]
    return list.map((option, index) => {
      return <li value={option.portfolioId} key={index} onClick={this.changeSelection}>
        <div className='text'>{option.name} {option.isDefault && !option.isShared ? ' (default)' : ''}</div>
        {option.isShared ? <div className='share-icon'><FaShareAlt/></div> : ''}</li>
    })
  },

  attachEventListenerToDocument () {
    document.addEventListener('click', this.handleOutsideClick)
  },

  removeEventListenerToDocument () {
    document.removeEventListener('click', this.handleOutsideClick)
  },

  toggleDropdown () {
    const val = this.state.isOpen
    this.setState({isOpen: !val}, () => {
      if (!val) {
        this.attachEventListenerToDocument()
      } else {
        this.removeEventListenerToDocument()
      }
    })
  },

  handleOutsideClick (e: any) {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({isOpen: false})
    } else {
      this.setState({isOpen: true})
    }
  },

  changeSelection (e) {
    const val = e.currentTarget.value
    if (val !== this.props.selected) {
      this.props.onChange(val)
    }
    this.toggleDropdown()
  },

  getValue (prop, val, key) {
    let items = filter(propEq(prop, val), this.props.data)
    if (items.length > 0) {
      let text = items[0].name + (items[0].isDefault && !items[0].isShared ? ' (default)' : '')
      if (key === 'isShared') {
        text = <span>{text} {items[0].isShared ? <FaShareAlt/> : null}</span>
      }
      return text
    }
    return ''
  },

  render () {
    return (
      <div className='select-dropdown-block' ref={(node) => { this.node = node }}>
        <button className='btn btn-default select-dropdown' type='button' disabled={this.props.disable}
          onClick={this.toggleDropdown}>
          <div title={this.getValue('portfolioId', this.props.selected, 'name')} className='button-text'>
            {(this.getValue('portfolioId', this.props.selected, 'isShared')) || 'Select'}
          </div>
          <div className='caret pull-right'></div>
        </button>
        <ul className='select-dropdown-menu'
          style={{'display': this.state.isOpen ? 'block' : 'none'}}>
          {this.renderOptions()}
        </ul>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/select-dropdown.js